// extracted by mini-css-extract-plugin
export default {"feedbackly":"tq17WtUox7MgfdqukQjF-Feedbackly-feedbackly"};